// extracted by mini-css-extract-plugin
export default {"wrapper":"JTSDtK2lV6I198x_lnci","dragIcon":"mwAXE0zGWFsH3O2vBdZp","removeButton":"F4tO856LI0NkdkwuJnSW"};